module.exports = __webpack_public_path__ + "img/image-lock.840f9657.svg";